// AUTO-GENERATED — do not edit manually.
// Run `pnpm codegen:opening-counts` to regenerate (requires a built @draughts/core).
//
// How many distinct openings each entry of the challenge "Apertura" dropdown can
// draw from. Rendered in the option labels, so the player sees the size of the
// pool they are picking.

/**
 * Legal opening SEQUENCES at 1, 2 and 3 half-moves, keyed by variant slug.
 * Counted by sequence, not by resulting position: transposing sequences are
 * distinct draws. Enumerated from the engine at generation time.
 */
export const OPENING_SEQUENCE_COUNTS: Readonly<Record<string, readonly [number, number, number]>> = {
  armenian: [8, 64, 720],
  brazilian: [7, 49, 302],
  canadian: [11, 121, 1222],
  croda: [14, 196, 2620],
  czech: [7, 49, 302],
  dameo: [8, 64, 708],
  english: [7, 49, 302],
  filipino: [7, 49, 302],
  frisian: [9, 81, 658],
  frysk: [9, 81, 657],
  german: [7, 49, 302],
  ghanaian: [9, 81, 658],
  international: [9, 81, 658],
  italian: [7, 49, 302],
  jamaican: [7, 49, 302],
  malaysian: [11, 121, 1452],
  nigerian: [9, 81, 658],
  pool: [7, 49, 302],
  portuguese: [7, 49, 302],
  russian: [7, 49, 302],
  sinhalese: [7, 49, 302],
  south_african: [13, 169, 2366],
  spanish: [7, 49, 302],
  thai: [7, 49, 392],
  triestine: [9, 81, 658],
  turkish: [8, 64, 708],
};

/**
 * Ballot entries at or below each strength ceiling 1..4 — i.e. the pool size of
 * `ballot1` … `ballot4`. Matches the federal tables: Italian C=83, B=126,
 * A∪B=166, general=174; English C=93, B=133, A=156, general=174.
 */
export const BALLOT_CEILING_SIZES: Readonly<
  Record<'italian' | 'english', readonly [number, number, number, number]>
> = {
  italian: [83, 126, 166, 174],
  english: [93, 133, 156, 174],
};
